import { useEffect } from 'react';
import { useSession } from '@erikdakoda/auth/client/betterAuthClient';
import { setStorageUserId } from '@erikdakoda/ui/shared/userScopedStorage';

/**
 * Keeps browser storage namespace aligned with the Better Auth session after load.
 * @returns Renders nothing
 */
export default function StorageUserSync(): null {
  'use memo';

  const { data: session, isPending } = useSession();

  useEffect(() => {
    if (isPending) {
      return;
    }
    setStorageUserId(session?.user.id ?? null);
  }, [isPending, session?.user?.id]);

  return null;
}
